import {
	CompanyDocumentApi,
	CompanyDocumentDTO,
	DocumentStatusEnum,
	DocumentTypeEnum,
} from "../Api";
import { getAuthConfiguration } from "./configuration";
import { arrayParamAjust } from "../utils/dataUtils";

const AuthCompanyDocumentApiFactory = () =>
	new CompanyDocumentApi(getAuthConfiguration());

export const getCompanyDocuments = (
	companyId: string,
	documentType?: Array<DocumentTypeEnum>,
	page?: number,
	pageSize?: number,
	validity?: DocumentStatusEnum
) => {
	return AuthCompanyDocumentApiFactory().apiCompanyDocumentGetAllCompanyIdGet({
		companyId,
		documentType: arrayParamAjust(documentType),
		page,
		pageSize,
		validity,
	});
};

export const downloadDocument = (documentId: string) => {
	return AuthCompanyDocumentApiFactory().apiCompanyDocumentDownloadDocumentDocumentIdGet(
		{ documentId }
	);
};

export const addNewDocument = (
	companyId: string,
	file: Blob,
	facultyId?: string,
	documentId?: string,
	documentType?: DocumentTypeEnum,
	expiresAt?: Date // expiry date
) => {
	return AuthCompanyDocumentApiFactory().apiCompanyDocumentUploadDocumentCompanyIdPut(
		{ companyId, file, facultyId, documentId, documentType, expiresAt }
	);
};

export const deleteDocument = (documentId: string) => {
	return AuthCompanyDocumentApiFactory().apiCompanyDocumentDeleteDocumentIdDelete(
		{ documentId }
	);
};

export const updateSkipOfferValidationStatus = (documentId: string) => {
	return AuthCompanyDocumentApiFactory().apiCompanyDocumentUpdateSkipOfferValidationStatusDocumentIdPut(
		{ documentId }
	);
};

export const rejectDocument = async (documentId: string, message: string) => {
	await AuthCompanyDocumentApiFactory().apiCompanyDocumentRejectDocumentDocumentIdPut(
		{ documentId, body: message }
	);
};

// Update epiry date of a document
export const updateDocumentExpiration = async (
	documentId: string,
	expiresAt: Date
) => {
	await AuthCompanyDocumentApiFactory().apiCompanyDocumentUpdateExpirationDocumentIdExpirationPut(
		{ documentId, body: expiresAt }
	);
};
